import { NbAuthService } from "@nebular/auth";
import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { switchMap, take } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private nbAuthService: NbAuthService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Exemplo: recupera token do localStorage (ou de algum serviço)

    return this.nbAuthService.getToken().pipe(
      // "take(1)" garante que pegaremos apenas o primeiro valor emitido
      take(1),
      switchMap((token) => {
        // Se existir token, clonar a request com o cabeçalho Authorization
        if (token) {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
          // Retorna o fluxo normal de requisição com a request clonada
          return next.handle(authReq);
        } else {
          // Se não houver token, segue sem alterar a request
          return next.handle(req);
        }
      })
    );
  }
}
